import {
  AuthFlowComplete,
  AuthFlowId,
  AuthStepDefinition,
  AuthStepId,
  AuthStepRoute,
  AuthTransitionKey,
} from '../../models/auth-flow.models';

export const TEL_VERIFICATION_STEP: AuthStepDefinition = {
  id: AuthStepId.TEL_VERIFICATION,
  route: AuthStepRoute.Tel,
  back: AuthStepId.CONFIRM_EMAIL,
  showLegalFooter: true,
  next: {
    [AuthFlowId.Login]: {
      [AuthTransitionKey.Default]: AuthFlowComplete.Complete,
    },
    [AuthFlowId.Registration]: {
      [AuthTransitionKey.Default]: AuthStepId.ONBOARDING,
    },
  },
};
